// extracted by mini-css-extract-plugin
export default {"header":"header__Dyflc","tailItem":"tailItem__0nARw"};